module.exports = __webpack_public_path__ + "img/logo-ooca-color.5fe48b36.png";